import {
    FC,
    PropsWithChildren,
    ReactNode,
    useEffect,
    useRef,
    useState,
} from 'react';
import { createPortal } from 'react-dom';

type Props = PropsWithChildren & {
    children: ReactNode;
    selector: string;
};

export const Portal: FC<Props> = ({ children, selector }) => {
    const ref = useRef<Element | null>(null);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        ref.current = document.querySelector<HTMLElement>(selector);
        setMounted(true);
    }, [selector]);

    return mounted && ref.current ? createPortal(children, ref.current) : null;
};
